import React, { useState, useContext } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { FormControlLabel, Checkbox, Button, AppBar, Toolbar, IconButton, Typography, Fab, Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext.js';
import { Context } from "../../contexts/siteContext.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function AddSystemVariable(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const systemVariable = props.model;
    const [variableName] = useState(props.model.VariableName);
    const [variableValue, setVariableValue] = useState(variableName !== "ClinicalHandOff" ? props.model.VariableValue : (props.model.VariableValue === "false" ? false : true));
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    let variableLabel;
    if (variableName === "InactiveTime" || variableName === "GracePeriod") {
        variableLabel = "Variable Value - (Unit: min)";
    }
    else if (variableName === "ObservationRows") {
        variableLabel = "Variable Value - (Unit: rows)";
    }
    else if (variableName === "SafetyCheckStartDate") {
        variableLabel = "Variable Value - (Safety Check Start Date)";
    }
    else if (variableName === "EmailContact" || variableName === "ManagerNotification") {
        variableLabel = "Variable Value - (Multiple email addresses can be separated by ';')";
    }
    else {
        variableLabel = "Variable Value";
    }

    let control;
    if (variableName === "InactiveTime" || variableName === "GracePeriod" || variableName === "ObservationRows" || variableName === "ClinicalHandOffTimeLimit") {
        control = <TextValidator
            validators={['required']}
            errorMessages={['This field is required']}
            variant="outlined"
            type="number"
            style={{ width: "100%" }}
            required
            label={variableLabel}
            value={variableValue}
            onChange={(e) => {
                setVariableValue(e.target.value < 0 ? (e.target.value = 0) : e.target.value);
                setModified(true);
            }}
            InputLabelProps={{
                shrink: true
            }}
        />
    }
    else if (variableName === "ClinicalHandOffNotification" || variableName === "ManagerNotification" || variableName === "EmailContact") {
        control = <TextValidator
            validators={['required']}
            errorMessages={['This field is required']}
            variant="outlined"
            style={{ width: "100%" }}
            rows="4"
            placeholder="Variable Value"
            multiline
            fullWidth
            label={variableLabel}
            value={variableValue}
            onChange={(e) => {
                setVariableValue(e.target.value);
                setModified(true);
            }}
            InputLabelProps={{
                shrink: true
            }}
        />
    }
    else if (variableName === "ClinicalHandOff") {
        control = <FormControlLabel
            label="Enable"
            labelPlacement="end"
            value="end"
            control={<Checkbox color="primary" />}
            checked={variableValue}
            onChange={(e) => {
                setVariableValue(e.target.checked);
                setModified(true);
            }}
        />
    }
    else if (variableName === "SafetyCheckStartDate") {
        control = <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker fullWidth hideTabs autoOk
                variant="inline"
                inputVariant="outlined"
                id="StartDate"
                format="MM/dd/yyyy"
                size="small"
                disablePast="true"
                value={variableValue}
                onChange={date => {
                    date = moment(date).format("MM/DD/YYYY");
                    setVariableValue(date);
                    setModified(true);
                }}
                InputAdornmentProps={{ position: "start" }}
                PopoverProps={{
                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                    transformOrigin: { horizontal: "left", vertical: "top" }
                }}
            />
        </MuiPickersUtilsProvider>
    }

    const saveSystemVariable = (goBack) => {
        if (modified) {
            let newVariableValue = "";
            let displayValue = "";
            if (variableName === "ClinicalHandOff") {
                newVariableValue = variableValue ? "1" : "0";
                displayValue = variableValue ? "true" : "false";
            }
            else {
                newVariableValue = variableValue.toString();
                displayValue = variableValue.toString();
            }

            systemVariable.SiteId = defaultSite.id
            systemVariable.VariableValue = newVariableValue;

            HttpService.post('/SystemVariable/SaveSystemVariable', systemVariable)
                .then(() => {
                    systemVariable.VariableValue = displayValue;
                    props.refreshGrid(systemVariable);
                    props.parentCallback();
                },
                    (error) => {
                        console.log(error);
                    });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    return (<>
        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => saveSystemVariable(true)} aria-label="back">
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant="h6" className={classes.title}>Edit System Variable</Typography>
                    </Grid>
                    <Grid item>
                        <StatusIcon />
                    </Grid>
                </Grid>
                <Grid container justify="flex-end">
                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                        <CloseIcon />
                    </Fab>
                    <SmallMenu modified={modified} saveCallback={() => saveSystemVariable(false)} />
                </Grid>
            </Toolbar>
        </AppBar>
        <GridContainer style={{ justifyContent: 'center' }}>
            <GridItem xs={12} sm={8} md={4}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => saveSystemVariable(false)} style={{ width: "100%", display: "block" }}>
                            <TextValidator
                                label="Variable Name"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                variant="outlined"
                                required
                                disabled
                                value={variableName}
                                style={{ width: "100%" }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                            <br /><br />
                            {control}
                            <br /> <br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </>
    );
}
